/**
 *
 * @module authenticationFlowResponse
 * @see https://github.bamtech.co/services-commons/public-api/blob/master/swagger/services/bam-idp.md#checkresponse
 *
 */

import Check from 'check-types';

import Exception from './../../exception/entry';

import AuthenticationFlow from './authenticationFlow';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    nonEmptyArray,
    includes
} = Check.assert;

/**
 *
 * @since 3.9.0
 * @type {SDK.Services.Identity.Bam.AuthenticationFlowResponse}
 *
 */
export default class AuthenticationFlowResponse {

    /**
     *
     * @param {Array<SDK.Services.Bam.Identity.AuthenticationFlow>} operations
     * @note `validOperations` is a list of allowed operations from the BamIdp Service. If the response doesn't contain
     * one of the pre-approved operations an error will be thrown. This indicates a change in the service contract.
     *
     */
    constructor(operations) {

        const errorMessage = {
            ctor: `${this.constructor.name}(operations)`,
            get operations() {
                return `${this.ctor} operations should be an Array of SDK.Services.Identity.Bam.AuthenticationFlow`;
            },
            get invalidOperation() {
                return `${this.ctor} operation should be a member of SDK.Services.Identity.Bam.AuthenticationFlow`;
            }
        };

        const validOperations = Object.values(AuthenticationFlow);

        nonEmptyArray(operations, errorMessage.operations, InvalidArgumentException);

        operations.forEach((operation) => {
            includes(validOperations, operation, errorMessage.invalidOperation, InvalidArgumentException);
        });

        /**
         *
         * @access public
         * @since 3.9.0
         * @type {Array<SDK.Services.Identity.Bam.AuthenticationFlow>}
         * @desc an array of operations that the application developer should use to determine if a user has been
         * registered with the BamIdp service
         *
         */
        this.operations = operations;

    }

}



// WEBPACK FOOTER //
// ./src/services/identity/bam/authenticationFlowResponse.js